export default __webpack_public_path__ + "c8b12f093489c15e844b600e67d4c1b3.png";